/** 
 * @file src/index.js
 * @description Module: src/index.js
 *
 * Notes:
 * - This codebase intentionally uses small, framework-agnostic DOM templates (no JSX).
 * - Keep functions pure where possible and keep side-effects (DOM mutations / fetch) explicit.
 */

import "./styles.css";
import App from "./App.js";

document.addEventListener("DOMContentLoaded", () => {
  try {
    App();
    console.log("ShelfQuest Digital Library App initialized successfully.");
  } catch (error) {
    console.error("Error initializing the app:", error);
  }
});
